import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import {
  RequestGetPostDto,
  RequestSetPostDto,
  RequestSetStatusPostDto,
  RequestGetLikeDto,
  RequestSetLikeDto,
  RequestSetCommentDto,
  RequestSetFollowDto,
  RequestGetFollowingDto,
  ResponseGetFollowing,
  RequestGetFollowerDto,
  ResponseGetFollower,
  RequestUnfollowDto
} from '../dto/post-service.dto';
import { Paginate } from '../../../../model/paginate';

@Injectable()
export class PostServiceNestApi {

  private service: string = '';
  private model: string = 'postservice';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public getPost(payload: RequestGetPostDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getPost';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public setPost(payload: RequestSetPostDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'setPost';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public setStatusPost(payload: RequestSetStatusPostDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'setStatusPost';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getLike(payload: RequestGetLikeDto): Observable<Paginate<any>> {
    const method: string = 'GET';
    const func: string = 'getLike';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<Paginate<any>>(method, url, params, urlParams, body);
  }

  public setLike(payload: RequestSetLikeDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'setLike';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getComment(payload: RequestGetLikeDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getComment';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public setComment(payload: RequestSetCommentDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'setComment';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public getFollowing(payload: RequestGetFollowingDto): Observable<ResponseGetFollowing> {
    const method: string = 'GET';
    const func: string = 'getFollowing';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetFollowing>(method, url, params, urlParams, body);
  }

  public getFollower(payload: RequestGetFollowerDto): Observable<ResponseGetFollower> {
    const method: string = 'GET';
    const func: string = 'getFollower';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public setFollow(payload: RequestSetFollowDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'setFollow';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  unFollow(data:RequestUnfollowDto){
    const method: string = 'POST';
    const func: string = 'unFollow';
    const params: any = data|| {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public setFollowApprove(payload: { id: number }): Observable<any> {
    const method: string = 'POST';
    const func: string = 'setFollowApprove';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/post-service.api.ts